import angular from 'angular';

import RwTermasOfUseComponent from './rw-terms-of-use-component';
import { RwTermsOfUseController } from './rw-terms-of-use-controller';
import rwTermsOfUseDialogModule from './components/rw-terms-of-use-dialog-module'


export default angular
  .module('rw-terms-of-use', [rwTermsOfUseDialogModule.name])
  .controller('RwTermsOfUseController', RwTermsOfUseController)
  .component('rwTermsOfUse', RwTermasOfUseComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-terms-of-use/rw-terms-of-use-module.js